<textarea #ta
          [formControl]="formControl"
          (keyup)="keyup($event)"
          (input)="onInput($event)"
          class="form-control"
          placeholder="{{ to.placeholder }}"
          pInputTextarea
          rows="1"
          [style.min-height.px]="32"
          [style.max-height.px]="to.maxHeight || 500"
          [style.overflow-y]="needsScroll ? 'auto' : 'hidden'"
          style="white-space: pre-wrap; resize: none;"
          cols="30"
          (change)="textAreaChanged($event)"></textarea>
